import { html, LitElement, css, unsafeCSS } from 'lit';

import { formatTimespan, isTouchDevice, timespanPercentage } from '../shared/utils';

import '../parts/card';
import '../parts/monster';

import './discorduser';

import style from './challenge.scss';

export class ChallengeComponent extends LitElement {

    static get properties() {
        return {
            challenge: Object,
            id: Number,
            highlight: Boolean
        }
    }

    constructor() {
        super();
        this.id = null;
        this.challenge = null;
        this.highlight = false;
    }

    connectedCallback() {
        super.connectedCallback();
        this.fetchData();
    }

    async fetchData() {
        let ret = await fetch(`./api/challenge/${this.id}`);
        let json = await ret.json();
        this.challenge = json.challenge;
        if (json.decks) {
            this.challenge.decks = json.decks;
        }
        this.update();
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    render() {

        if (!this.challenge) {
            return html``;
        }

        let ts = formatTimespan(new Date(), new Date(this.challenge.to), true) + ' left';
        if (new Date(this.challenge.to) < new Date())
            ts = "Finished";
        if (new Date(this.challenge.from) > new Date())
            ts = "Not Started";
        let perc = timespanPercentage(this.challenge.from, this.challenge.to);
        if (perc > 100)
            perc = 100;

        const diffs = ['Impossible', 'Hard', 'Challenging', 'Normal'];

        return html`
            <div class="challenge" style="${this.highlight === 'true' ? 'border-color: #0c0c0c;box-shadow: 0px 0px 0px 3px rgb(153, 153, 153);border-width: 3px;' : ''}">                 
                ${this.highlight ? html`<h3 class="class-seeker">Weekly Challenge</h3>` : ''}   
                <h2 style="${!this.highlight ? 'margin-top:0' : ''}"><a href="./challenge/${this.challenge.uid}" style="color:rgb(213, 156, 60)">${this.challenge.image ? html`<card-part id=${this.challenge.image} imageonly="true" header="true"
                    style="${!isTouchDevice()?'float: right;':''}"></card-part>`: ''}${this.challenge.name}</a></h2>
                ${this.challenge.intro ? html`
                    <p class="news-blue">${this.challenge.intro}</p>
                `: ''}
                <p>
                    Post runs between <strong>${(new Date(this.challenge.from)).toLocaleString()}</strong> to <strong>${(new Date(this.challenge.to)).toLocaleString()}</strong> (your local timezone).<br><span style="font-weight:bold;">Minimum game version ${this.challenge.version} required.</span>
                </p>                                                                                                                                     
                <span class="bubble big progress"><span class="progress-bar" style="width:${perc}%;"></span><h3 class="progress-text">${this.challenge.decks || 0} Runs submitted</h3><h3 class="progress-text-right">${ts}</h3></span>
                ${this.challenge.winners?.length > 0 ? html`
                    <h2>Winners</h2>                    
                    ${this.challenge.winners.map((win,i) => html`
                        <div class="line"><b>${diffs[i]}</b>${isTouchDevice()?html`<br>`:''} <discorduser-component user=${win}></discorduser-component></div>
                    `)}
                `: ''}
                ${this.highlight === 'true' ? html`
                <a href="./challenge/${this.challenge.uid}" style="display:block;margin-top:8px;">More details and runs</a>    
                `: ''}                
            </div>  
        `;
    }
}

customElements.define('challenge-component', ChallengeComponent);